export const ROUTES = {
  home: '/',
  messages: '/pranesimai',
  message: '/pranesimai/:id',
  editMessage: '/pranesimai/:id/redaguoti',
  newMessage: '/naujas-pranesimas/*',
  newMessageSuccess: '/naujas-pranesimas/uzregistruotas',
  map: '/zemelapis',
  stats: '/statistika',
  signIn: '#prisijungti',
  vilniusLogin: '/vilnius-login',
  support: '/pagalba',
  profile: '/profilis',
  termsOfUse: '/naudojimosi-salygos',
  myMessages: '/mano-pranesimai',
  authorized: '/authorized',
  bookmarks: '/isiminti-pranesimai',
  testSentry: '/test-sentry',
} as const;
